<template>
	<div class="main-top">
		<home-nav></home-nav>

		<!-- Trazilica banner -->
		<section id="uvjeti-banner" class="uvjeti-banner-area">
			<div class="overlay overlay-bg"></div>
			<div class="container">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 uvjeti-banner-content">
						<div class="row">
							<div class="col-12">
								<h1 class="text-center">Kako rezervirati?</h1>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>


		<section class="my-5">
			<div class="container">
				<div class="row">
					<div class="col-md-12 text-justify">
						<p><b>1. Pošalji zahtjev za rezervaciju termina</b><br>
							Na stranici salona odaberi uslugu koju želiš rezervirati. U prozorčiću za rezervacije redom odaberi djelatnika, datum i vrijeme rezervacije, a možeš dodati i još usluga za istog djelatnika i napomenu salonu. Nakon što si sve odabrao, pregledaj detalje narudžbe i pošalji zahtjev za rezervaciju.</p>
							<p><b>2. Pričekaj odgovor salona</b><br>
							Vrijeme odgovora salona na tvoj zahtjev za rezervaciju ovisi o svakom salonu posebno. Salon može potvrditi ili odbiti tvoj zahtjev - u svakom slučaju dobiti ćeš odgovor salona na mail.</p>
							<p><b>3. Otiđi na dogovoreni termin</b><br>
							Ukoliko je salon potvrdio rezervaciju, sat vremena prije termina stići će ti podsjetnik na dogovoreni termin. Molimo te da poštuješ zakazano vrijeme zbog salona i drugih klijenata. Ukoliko ne dođeš na dogovoreni termin, salon ima opciju označiti termin kao nedolazak, a što će biti vidljivo i svim ostalim salonima kojima budeš slao zahtjev.</p>
							<p><b>4. Ocijeni i komentiraj kvalitetu pruženih usluga</b><br>
							Nakon što je vrijeme termina prošlo na mail će ti stići obavijest da možeš ocijeniti i komentirati usluge salona. Figaro.hr zadržava sva prava da izbriše sve komentare koje smatra da nisu u skladu s pravilima komentiranja.</p>
					</div>
				</div>
			</div>
		</section>


		<home-footer></home-footer>
	</div>
</template>
<script>
	export default {
		name: 'home',
	}

</script>
